import { render, staticRenderFns } from "./rekonardb.vue?vue&type=template&id=c77f7b30&scoped=true"
import script from "./rekonardb.vue?vue&type=script&lang=js"
export * from "./rekonardb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77f7b30",
  null
  
)

export default component.exports